<template>
  <v-select
    :items="tipos"
    label="Tipo do pedido"
    item-text="text"
    item-value="value"
    v-model="tipoSelecionado"
  />
</template>

<script>
export default {
  name: 'FiltroTipoPedido',
  data() {
    return {
      tipos: [
        {
          text: 'Todos',
          value: null
        },
        {
          text: 'Mesa',
          value: 0
        },
        {
          text: 'Delivery',
          value: 1
        },
        {
          text: 'Comanda fácil',
          value: 2
        }
      ],
      tipoSelecionado: null
    }
  },
  watch: {
    tipoSelecionado() {
      this.$emit('filtrar-tipo-pedido', {
        tipo: this.tipoSelecionado
      })
    }
  }
}
</script>
